import { NavLink, Navigate, Outlet, Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";
import { Login } from "./pages/Login";
import { AuthCallback } from "./pages/AuthCallback";
import { Projects } from "./pages/Projects";
import { OrganizationsPage } from "./pages/OrganizationsPage";
import { OrgDetailPage } from "./pages/OrgDetailPage";
import { ProjectDetailPage } from "./pages/ProjectDetailPage";
import { RepoExplorer } from "./pages/RepoExplorer";
import { AnalysisPage } from "./pages/AnalysisPage";
import { SearchPage } from "./pages/SearchPage";
import { ArchitecturePage } from "./pages/ArchitecturePage";
import { ApiKeys } from "./pages/ApiKeys";
import { AdminPage } from "./pages/AdminPage";
import { AppSidebar } from "./components/AppSidebar";
import { GraphProvider } from "./context/GraphContext";
import { FilterProvider } from "./context/FilterContext";
import { useGraphContext } from "./context/GraphContext";
import { useAuth } from "./lib/auth";
import CustomButton from "./components/CustomButton";

function RepoLayout() {
  const { projectId = "", repoId = "" } = useParams();
  return (
    <GraphProvider projectId={projectId} repoId={repoId}>
      <RepoLayoutInner projectId={projectId} repoId={repoId} />
    </GraphProvider>
  );
}

function RepoLayoutInner({ projectId, repoId }: { projectId: string; repoId: string }) {
  const { graphData } = useGraphContext();
  return (
    <FilterProvider graphData={graphData}>
      <div className="app-body">
        <AppSidebar projectId={projectId} repoId={repoId} />
        <main className="repo-content">
          <Outlet />
        </main>
      </div>
    </FilterProvider>
  );
}

export function App() {
  const { authed, isAdmin, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const isPublicPath =
    loc.pathname === "/login" || loc.pathname === "/login/callback" || loc.pathname.startsWith("/organizations");

  if (!authed && !isPublicPath) return <Navigate to="/login" replace />;

  return (
    <div className="app">
      <header className="topbar">
        {authed && <NavLink to="/projects">Projects</NavLink>}
        {authed && <NavLink to="/api-keys">API keys</NavLink>}
        <NavLink to="/organizations">Organizations</NavLink>
        {authed && isAdmin && <NavLink to="/admin">Admin</NavLink>}
        <span className="spacer" />
        {authed && <CustomButton loading={false} buttonText="Sign out" buttonTextLoading="" handleSubmitClick={logout} />}
        {!authed && <CustomButton loading={false} buttonText="Sign in" buttonTextLoading="" handleSubmitClick={() => nav("/login")} />}
      </header>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login/callback" element={<AuthCallback />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="/organizations/:orgId" element={<OrgDetailPage />} />
        <Route path="/organizations/:orgId/projects/:projectId" element={<ProjectDetailPage />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:projectId/repos/:repoId" element={<RepoLayout />}>
          <Route path="explore" element={<RepoExplorer />} />
          <Route path="analysis" element={<AnalysisPage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="architecture" element={<ArchitecturePage />} />
        </Route>
        <Route path="/api-keys" element={<ApiKeys />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<Navigate to={authed ? "/projects" : "/login"} replace />} />
      </Routes>
    </div>
  );
}
